<template>
  <div>
    <!-- Title-->
    <!-- <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition" >{{ alert_message }}</v-alert>
    </div> -->
    <loading v-model:active="loading"
        :can-cancel="true"
        :color="primary_code"
        :is-full-page="mainFullPage"/>
    <div>
      <div v-if=" headerText === 'D2C Return Approval' || headerText === 'Internal Return Request Approval' || headerText === 'Warranty Claim Approval' || headerText === 'Dealer/Partner Return Approval' || headerText === 'Reverse Logistics' || headerText === 'Customer Case Approval'" >
        <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />
      </div>
    </div>
  <approval_decision v-if="headerText !== 'Reverse Logistics'" :start_loading="start_loading" :stop_loading="stop_loading"/>
    <!-- Header -->
    
    <!-- Image show popup -->
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <span class="headline">Images</span>
          <v-spacer></v-spacer>
          <v-btn icon variant="solo" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider :thickness="2" class="border-opacity-25 m-0"/>
        <v-card-text>
          <v-row>
            <v-col v-for="(imageUrl, index) in item_images" :key="index" cols="4">
              <v-img :src="imageUrl" width="100%" contain></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="videoDialogVisible" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title>
          <span class="headline">Videos</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-for="(videoUrl, index) in item_videos" :key="index" cols="4">
              <video :key="videoUrl" width="100%" controls>
                <source :src="videoUrl" width="100%" :type="mp4">
              </video>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

     <!--  view error log popup -->
     <v-row justify="center">
      <v-dialog v-model="viewErrorLogPopup" persistent max-width="900px">
        <v-card class="v-card-100">
          <v-card-title>
            <v-row class="ma-1">
            <span>Error Message</span>
            <v-spacer></v-spacer>
            <!-- <v-btn icon @click="viewErrorLogPopup = false"> -->
              <v-icon @click="viewErrorLogPopup = false">mdi-close</v-icon>
            <!-- </v-btn> -->
          </v-row>
          </v-card-title>
          <v-card-text class="text-left">
            <!-- <h6>{{this.error_log_data}}</h6> -->
            <v-row>
            <v-col cols="12" sm="3" md="3">
              <strong>Request Payload :</strong>
            </v-col>
            <v-col cols="12" sm="9" md="9">
              {{this.request_log}}
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="12" sm="3" md="3">
            <strong>Response Payload :</strong>
            </v-col>
            <v-col cols="12" sm="9" md="9">
              {{this.response_log ? this.response_log : this.error_log_data}}
            </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    
    <v-card class="v-card v-sheet theme--light mt-5 overflow-auto" style="max-width: 100% !important;">
      <v-card-text>
        <div v-if="(headerText === 'Warranty Claim Approval' || headerText === 'Customer Case Approval') && (action !== 'from_home_approve')">
          <!-- Empty v-card for Warranty Claim History -->
          <v-tabs>
            <v-tab
              ripple
              :href="'#'"
              @click="loadData(tab, 'tab_clicked')"
              style="text-transform:none!important;text-decoration: none;padding-top: 4px;"
              v-for="(tab, index) in tabs"
              :key="index"
            >
              {{ tab }}
            </v-tab>
          </v-tabs>
        </div>
        <!-- v-expansion-panels for different sections -->
        <div v-if="(activeTab == 'Ticket Details' || headerText === 'D2C Return Approval' || headerText === 'Internal Return Request Approval' || headerText === 'Dealer/Partner Return Approval') && (action !== 'from_home_approve')">
          <!-- <v-row>
            <v-col class="pb-0">
              <p class="ml-7 expansion-panel-text">Request Type :</p>
            </v-col>
            <v-col class="pb-0">
              <p class="expansion-panel-text">
                <strong>{{ lebal_request }}</strong>
              </p>
            </v-col>
          </v-row> -->

          <div class="p-3">
            <!-- Status And Decision Details -->
            <v-row class="p-3 customer-details" v-if="this.headerText == 'Reverse Logistics'">
              <label>Status And Decision Details</label>
            </v-row>
            <v-row class="p-3" v-if="this.headerText == 'Reverse Logistics'">
              <v-col col="12" sm="4" md="4" lg="4" class="text-left" v-if="headerText === 'Dealer/Partner Return Approval'">
                <p >Purchase Price (₹)</p>
                <p class="detail-heading" v-if="item_details.dealer_purchase_value == 0">{{item_details.dealer_purchase_value}}</p>
                <p class="detail-heading" v-else-if="item_details.dealer_purchase_value == null">{{"-"}}</p>
                 <p class="detail-heading" v-else>{{ shouldShowActualValue ? item_details.dealer_purchase_value : '****' }} </p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left" v-if="headerText === 'Warranty Claim Approval' || headerText === 'Customer Case Approval'">
                <p >Purchase Price (₹)</p>
                <p class="detail-heading" v-if="item_details.purchase_price == 0">{{item_details.purchase_price}}</p>
                <p class="detail-heading" v-else-if="item_details.purchase_price == null">{{"-"}}</p>
                <p class="detail-heading" v-else>{{shouldShowActualValue ? item_details.purchase_price : '****'}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Sub-Request Status</p>
                <p class="detail-heading">{{ item_details.status ? item_details.status : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Approval Pending At</p>
                <p class="detail-heading">{{ item_details.approval_pending_from ? item_details.approval_pending_from : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Customer Resolution Decision</p>
                <p class="detail-heading">{{item_details.customer_resolution_decision ? item_details.customer_resolution_decision : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Customer Resolution Status</p>
                <p class="detail-heading"> {{item_details.customer_resolution_status ? item_details.customer_resolution_status : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Item Decision</p>
                <p class="detail-heading">{{item_details.item_decision ? item_details.item_decision : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Item Decision Status</p>
                <p class="detail-heading"> {{item_details.item_decision_status ? item_details.item_decision_status : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >CSE Comment</p>
                <p class="detail-heading">{{item_details.cse_comments ? item_details.cse_comments : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Re-Propose Comment</p>
                <p class="detail-heading">{{item_details.re_propose_comments ? item_details.re_propose_comments : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Recommandation Comment</p>
                <p class="detail-heading">{{ item_details.recommend_comments ? item_details.comments : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left" v-if="headerText === 'Dealer/Partner Return Approval'">
                <p >Purchase Date</p>
                <p class="detail-heading">{{ item_details.dealer_purchase_invoice_date ? formatDate(item_details.dealer_purchase_invoice_date) : "-" }}</p>
              </v-col>
              <!-- <v-col col="12" sm="4" md="4" lg="4" v-else>
                <p >Purchase Date</p>
                <p class="detail-heading">{{ item_details.purchase_date  ? item_details.purchase_date : "-" }}</p>
              </v-col> -->
              <v-col col="12" sm="4" md="4" lg="4" class="text-left" v-if="(currentUser === 'branch_sales_manager' || currentUser === 'regional_business_head' || currentUser === 'product_head' || currentUser === 'branch_finance_manager' || currentUser === 'regional_finance_manager')">
                <p >Depreciation (₹)</p>
                <p class="detail-heading" v-if="item_details.depriciation == 0">{{item_details.depriciation}}</p>
                <p class="detail-heading" v-else-if="item_details.depriciation == null">{{"-"}}</p>
                <p class="detail-heading" v-else>{{shouldShowActualValue ? item_details.depriciation : '****'}}  <span><v-icon color="primary">mdi-circle-info</v-icon></span></p>
              </v-col>
              <!-- <v-col col="12" sm="4" md="4" lg="4">
                <p >Expected Liquidation Value (₹)</p>
                <p class="detail-heading" v-if="item_details.expected_liquidation == 0">{{item_details.expected_liquidation}}</p>
                <p class="detail-heading" v-else-if="item_details.expected_liquidation == null">{{"-"}}</p>
                <p class="detail-heading" v-else>{{item_details.expected_liquidation}}</p>
              </v-col> -->
              <!-- <v-col col="12" sm="4" md="4" lg="4">
                <p >Approved By</p>
                <p class="detail-heading">{{ item_details.approved_by ? item_details.approved_by : "-" }}</p>
              </v-col> -->
            </v-row>
            <!-- Customer Entity Details -->
            <v-row class="p-3 customer-details">
              <label>Customer Entity Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Customer/Entity Name*</p>
                <p class="detail-heading">{{item_details.customer_name ? item_details.customer_name : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p>Customer in CRM</p>
                <p class="detail-heading">{{item_details.dealer_pan ? item_details.dealer_pan : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Customer/Entity Type</p>
                <p class="detail-heading">{{item_details.customer_type ? item_details.customer_type : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Contact Numer*</p>
                <p class="detail-heading">{{item_details.contact_number ? item_details.contact_number : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Alternate Contact Number*</p>
                <p class="detail-heading">{{item_details.alternate_contact_number ? item_details.alternate_contact_number : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Item Location(Address)*</p>
                <p class="detail-heading">{{item_details.item_location ? item_details.item_location : "-"}}</p>
              </v-col>
            </v-row>

            <!-- Item Details -->
            <v-row class="p-3 customer-details">
              <label>Item Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Tag ID</p>
                <p class="detail-heading">{{item_details.tag_number ? item_details.tag_number : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Article ID</p>
                <p class="detail-heading">{{item_details.sku_code ? item_details.sku_code : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Article Description</p>
                <p class="detail-heading">{{item_details.sku_description ? item_details.sku_description : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left"  v-if="headerText === 'Dealer/Partner Return Approval'">
                <p >Alternate Contact Number*</p>
                <p class="detail-heading">{{item_details.alternate_contact_number ? item_details.alternate_contact_number : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Serial Number</p>
                <p class="detail-heading">{{item_details.serial_number ? item_details.serial_number : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Article Id Being Sale On Exchange</p>
                <p class="detail-heading">-</p>
              </v-col>
            </v-row>

            <!-- Test Details -->
            <v-row class="p-3 customer-details">
              <label>Test Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Test Results</p>
                <p class="detail-heading"><a @click="showTestResult()" style="color: #1976d2;"><u>View</u></a></p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >AI Discrepancy Report</p>
                <p class="detail-heading">-</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Service Partner</p>
                <p class="detail-heading">{{item_details.service_partner_name ? item_details.service_partner_name : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Service Technician</p>
                <p class="detail-heading">{{item_details.service_technician_name ? item_details.service_technician_name : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Validation Status</p>
                <p class="detail-heading">{{item_details.policy ? item_details.policy : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Item condition</p>
                <p class="detail-heading">{{ item_details.repairable_status ? item_details.repairable_status : "-" }}</p>
              </v-col>
              <v-col col="12" sm="3" md="3" lg="3" class="text-left">                    
                    <p>Grading Details</p>
                    <p>
                        <a 
                          v-if="checkGradingDetails"
                          @click="viewPackaging"
                          style="color: #1976d2; cursor: pointer;">
                          <u>View All</u>
                        </a>
                        <span v-else
                              style="color: #aaa; cursor: not-allowed;">
                          <u>View All</u>
                        </span>
                      </p>
                  </v-col>
            </v-row>

            <!-- Customer Declaration Details -->
            <v-row class="p-3 customer-details">
              <label>Customer Declaration</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Issue Reported</p>
                <p class="detail-heading">{{  item_details.issue_reported  ? item_details.issue_reported  : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Type of damage</p>
                <p class="detail-heading">{{ item_details.type_of_incident_or_damage  ? item_details.type_of_incident_or_damage : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Vendor Responsible for Damage</p>
                <p class="detail-heading">{{item_details.vendor_responsible ? item_details.vendor_responsible : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Images</p>
                <a @click="viewCustomerDeclarationImages(item_details)" v-if="item_details.images != ''" style="cursor: pointer">
                  <span style="text-decoration: underline;color:#1976d2;">View All</span>
                </a>
                <span class="detail-heading" v-else>-</span>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p>Videos</p>
                <a @click="viewCustomerDeclarationVideos(item_details)" v-if="item_details.videos != ''">
                  <span style="text-decoration: underline;color:#1976d2;">View All</span>
                </a>
                <span class="detail-heading" v-else>-</span>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Condition Questions</p>
                <p class="detail-heading">-</p>
              </v-col>
            </v-row>

            <!-- Other Details -->
            <v-row class="p-3 customer-details">
              <label>Other Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Channel</p>
                <p class="detail-heading">{{  item_details.channel ? formatResponse(item_details.channel)  : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Return Sub-Type</p>
                <p class="detail-heading">{{ item_details.return_request_sub_type ? formatResponse(item_details.return_request_sub_type) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Return Reason</p>
                <p class="detail-heading">{{item_details.return_reason ? formatResponse(item_details.return_reason) : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Return Sub-Reason</p>
                <p class="detail-heading">{{item_details.return_sub_reason ? formatResponse(item_details.return_sub_reason) : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Branch</p>
                <p class="detail-heading">{{item_details.branch ? formatResponse(item_details.branch) : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Region</p>
                <p class="detail-heading">{{item_details.region ? formatResponse(item_details.region) : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Zone</p>
                <p class="detail-heading">{{item_details.zone ? formatResponse(item_details.zone) : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Sales Manager</p>
                  <!-- <p class="detail-heading">{{item_details.sales_manager ? formatResponse(item_details.sales_manager) : "-"}}</p> -->
                  <p class="detail-heading">-</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Ticket Initiator</p>
                <p class="detail-heading">{{item_details.ticket_initiator ? item_details.ticket_initiator : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Repair Partner</p>
                <p class="detail-heading">{{ formatResponse(item_details.repair_partner) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Repair Executive</p>
                <p class="detail-heading">{{  formatResponse(item_details.repair_executive) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Grading Partner</p>
                <p class="detail-heading">{{ formatResponse(item_details.grading_partner) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Grading Executive</p>
                <p class="detail-heading">{{ formatResponse(item_details.grading_executive )}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Request Creation Date</p>
                <p class="detail-heading">{{formatResponse(item_details.created_date ) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Ageing</p>
                <p class="detail-heading" v-if="item_details.ageing == 0">{{item_details.ageing}}</p>
                <p class="detail-heading" v-else-if="item_details.ageing == null">{{"-"}}</p>
                <p class="detail-heading" v-else>{{item_details.ageing}}</p>
              </v-col>
            </v-row>

            <!-- Status And Decision Details -->
            <v-row class="p-3 customer-details" v-if="this.headerText !== 'Reverse Logistics'">
              <label>Status And Decision Details</label>
            </v-row>
            <v-row class="p-3" v-if="this.headerText !== 'Reverse Logistics'">
              <v-col col="12" sm="4" md="4" lg="4" class="text-left" v-if="headerText === 'Dealer/Partner Return Approval'">
                <p >Purchase Price (₹)</p>
                <p class="detail-heading" v-if="item_details.dealer_purchase_value == 0 && shouldShowActualValue">{{item_details.dealer_purchase_value}}</p>
                <p class="detail-heading" v-else-if="item_details.dealer_purchase_value == null && shouldShowActualValue">{{"-"}}</p>
                <p class="detail-heading" v-else>{{ shouldShowActualValue ? item_details.dealer_purchase_value : '****' }} </p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left" v-if="headerText === 'Warranty Claim Approval' || headerText === 'Customer Case Approval'">
                <p >Purchase Price (₹)</p>
                <p class="detail-heading" v-if="item_details.purchase_price == 0 && shouldShowActualValue">{{item_details.purchase_price}}</p>
                <p class="detail-heading" v-else-if="item_details.purchase_price == null && shouldShowActualValue">{{"-"}}</p>
                <p class="detail-heading" v-else>{{shouldShowActualValue ? item_details.purchase_price : '****'}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Purchase Invoice Date</p>
                <p class="detail-heading">{{ item_details.dealer_purchase_invoice_date ? formatDate(item_details.dealer_purchase_invoice_date) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Customer Invoice Date</p>
                <p class="detail-heading">{{ formatDate(item_details.purchase_date) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Depreciation (₹)</p>
                <p class="detail-heading" v-if="item_details.depriciation == 0 && shouldShowActualValue">{{item_details.depriciation}}</p>
                <p class="detail-heading" v-else-if="item_details.depriciation == null && shouldShowActualValue">{{"-"}}</p>
                <p class="detail-heading" v-else>{{shouldShowActualValue ? item_details.depriciation : '****'}} 
                  <v-tooltip right class="custom-tooltip">
                    <template v-slot:activator="{ props }">
                      <v-icon style="font-size:20px !important; top:-3px !important;" color="secondary" v-bind="props" class="ml-2">mdi-alert-octagon</v-icon>
                    </template>
                    <span>
                      Purchase Date: {{ 
                          shouldShowActualValue 
                          ? (item_details.return_type === 'Dealer-Partner Sales Return' 
                              ? formatDate(item_details.dealer_purchase_invoice_date) 
                              : formatDate(item_details.purchase_date)
                            ) 
                          : '****' 
                        }}<br>
                        Ageing: 
                     <span v-if="shouldShowActualValue">
                        <span v-if="item_details.depreciation_from === 731 && item_details.depreciation_to === null"> <v-icon>mdi-chevron-right</v-icon>{{ item_details.depreciation_from }}</span>
                        <span v-else>{{ item_details.depreciation_from || 0}} - {{ item_details.depreciation_to || 0}}</span>
                      </span>
                      <span v-else>****</span><br>
                      Percentage: {{ shouldShowActualValue ? item_details.depreciation_percent : '****' }}
                    </span>
                  </v-tooltip>
                 </p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Expected Liquidation Value (₹)</p>
                <p class="detail-heading" v-if="item_details.expected_liquidation == 0">{{item_details.expected_liquidation}}</p>
                <p class="detail-heading" v-else-if="item_details.expected_liquidation == null">{{"-"}}</p>
                <p class="detail-heading" v-else>{{item_details.expected_liquidation}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Sub-Request Status</p>
                <p class="detail-heading">{{ item_details.status ? item_details.status : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Approval Pending At</p>
                <p class="detail-heading">{{ item_details.approval_pending_from ? item_details.approval_pending_from : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Approved By</p>
                <p class="detail-heading">{{ item_details.approved_by ? item_details.approved_by : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Customer Resolution Decision</p>
                <p class="detail-heading">{{item_details.customer_resolution_decision ? item_details.customer_resolution_decision : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Customer Resolution Status</p>
                <p class="detail-heading"> {{item_details.customer_resolution_status ? item_details.customer_resolution_status : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Item Decision</p>
                <p class="detail-heading">{{item_details.item_decision ? item_details.item_decision : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Item Decision Status</p>
                <p class="detail-heading"> {{item_details.item_decision_status ? item_details.item_decision_status : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >CSE Comment</p>
                <p class="detail-heading">{{item_details.cse_comments ? item_details.cse_comments : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Re-Propose Comment</p>
                <p class="detail-heading">{{item_details.re_propose_comments ? item_details.re_propose_comments : "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4" class="text-left">
                <p >Recommandation Comment</p>
                <p class="detail-heading">{{ item_details.recommend_comments ? item_details.comments : "-"}}</p>
              </v-col>
            </v-row>
            <!-- API Integration -->
            <v-row class="p-3 customer-details" v-if="!$isWhirlpoolClient() && action !== 'by_link_approve_reverse_logi'">
              <label>API Integration</label>
            </v-row>
            <v-row class="p-3" v-if="!$isWhirlpoolClient() && action !== 'by_link_approve_reverse_logi'">
              <v-data-table 
                :dense="true"  
                density="compact"
                v-model="selected2" 
                disable-pagination 
                :hide-default-footer="true"
                :headers="api_headers"
                :items="api_table_data"
                :loading="loading"
                fixed-header
                height="100%"
                return-object
                loading-text="Loading Data... Please wait"
                class="elevation-1" style="width:100%;box-shadow: none !important;">
                <template #[`item.request_type`]="{ item }">
                  <span v-if="item.request_type == 'PUSH' || item.request_type == 'push'">Outbound</span>
                  <span v-else-if="item.request_type == 'pull'">Inbound</span>
                  <span v-else>-</span>
                </template>
                <template #[`item.status`]="{ item }">
                    <span v-if="item.status == 'failed'">Failed</span>
                    <span v-else-if="item.status == 'completed' || item.status == 'success'">Success</span>
                    <span v-else>-</span>
                  </template>
                <template #[`item.error_string`]="{ item }">
                  <a @click="itemDetailpopup(item)" style="color: #1976d2; cursor: pointer !important;">
                      <u>View</u>
                    </a>
                    <!-- <span v-else>-</span> -->
                  </template>
                  <template #[`item.re_trigger`]="{ item }">
                    <v-btn
                      v-if="
                        (item.request_type.toLowerCase() === 'push' && (item.status.toLowerCase() === 'completed' || item.status.toLowerCase() === 'success')) ||
                        ((item.request_type.toLowerCase() === 'push' && item.status.toLowerCase() === 'failed') || 
                        (item.request_type.toLowerCase() === 'pull' && item.status.toLowerCase() === 'failed'))
                      "
                      class="m-2"
                      label="RE-TRIGGER"
                      :disabled="!item.enable_retrigger"
                      variant="outlined"
                      color="primary"
                      @click="retrigger(item)"
                    >
                      RE-TRIGGER
                    </v-btn>
                    <span v-else-if="!(item.request_type.toLowerCase() === 'push' && item.status.toLowerCase() === 'success') || !(item.request_type.toLowerCase() === 'pull' && item.status.toLowerCase() === 'success')">-</span>
                  </template>
                <template #bottom></template>
              </v-data-table>
            </v-row>
          </div>
        </div>
        <v-row class="m-0" v-if="action === 'from_home_approve'">
          <v-row class="p-3 m-1 mb-1 customer-details">
            <label>Selected Requests</label>
          </v-row>
          <v-layout class="mt-2" column>
            <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
              <v-data-table
                :dense="true"
                v-model:selected="selected"
                :show-select="true"
                :items="selected_table"
                disable-pagination
                :hide-default-footer="true"
                :headers="selected_headers"
                fixed-header
                height="100%"
                return-object
                loading-text="Loading Data... Please wait"
                class="elevation-1"
              >

              <template v-for="(header, index) in selected_headers" :key="index" v-slot:[`item.${header.value}`]="{ item }">
                <span v-if="header.value !== 'return_sub_request_id'">
                  <span v-if="item[header.value] !== null && item[header.value] !== ''">
                    {{ item[header.value] }}
                  </span>
                  <span v-else>
                    <span>-</span>
                  </span>
                </span>
                <span v-else>
                  <a @click="subRequestDialog(item)" style="color: #1976d2; cursor: pointer;">
                    <u>{{ item.return_sub_request_id }}</u>
                  </a>
                </span>
              </template>
                <template #[`item.item_location`]="{ item }">
                  <span v-if="item.item_location !== null && item.item_location.length <= 30">
                      {{ item.item_location }}
                    </span>
                    <span v-else-if="item.item_location === null">
                      N/A
                    </span>
                    <span v-else>
                      <v-tooltip location="top" text="item.item_location">
                        <template v-slot:activator="{ props }">
                          <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.item_location)">
                            {{ item.item_location.substring(0, 25) }}...
                          </a>
                        </template>
                        <span>{{ item.item_location }}</span>
                      </v-tooltip>
                    </span>
                </template>
                <template #[`item.images`]="{ item }">
                  <a @click="viewCustomerDeclarationImages(item)" v-if="item.images != ''">
                    <span style="text-decoration: underline;color:#1976d2;">View Image</span>
                  </a>
                  <span v-else>-</span>
                </template>
              </v-data-table>
            </v-col>
          </v-layout>
        </v-row> 
        <v-row class="m-0" v-if="activeTab == 'Claim History'">
        <v-layout column>
          <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
            <v-data-table
              :dense="true"
              v-model="selected"
              :items="table_data"
              disable-pagination
              :hide-default-footer="true"
              :headers="headers"
              fixed-header
              return-object
              height="100%"
              loading-text="Loading Data... Please wait"
              class="elevation-1"
            >
            <template #[`item.issue`]="{ item }">
              <span v-if="item.issue === null || item.issue === ''">-</span>
              <span v-else>{{ item.issue }}</span>
            </template>
            <template #[`item.warranty_claim_date`]="{ item }">
              <span v-if="item.warranty_claim_date === null || item.warranty_claim_date === ''">-</span>
              <span v-else>{{ formattedDate(item.warranty_claim_date) }}</span>
            </template>
            <template #[`item.warranty_resolution_date`]="{ item }">
              <span v-if="item.warranty_resolution_date === null || item.warranty_resolution_date === ''">-</span>
              <span v-else>{{ formattedDate(item.warranty_resolution_date) }}</span>
            </template>

            </v-data-table>
          </v-col>
        </v-layout>
      </v-row>
    </v-card-text>

      <!-- <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          class="text-none"
          v-if="headerText == 'Internal Return Request Approval'"
          @click="approveDecision(item)"
          >Approve Decision</v-btn
        >
        <v-btn
          color="primary"
          class="text-none"
          v-if="headerText == 'D2C Return Approval'"
          @click="approveDecisionD2C(item)"
          >Approve Decision</v-btn
        >
        <v-btn
          color="primary"
          class="text-none"
          v-if="headerText == 'Warranty Claim Approval'"
          @click="approveDecisionWarranty(item)"
          >Approve Decision</v-btn
        >
        <v-btn
          color="primary"
          class="text-none"
          v-if="headerText == 'Dealer/Partner Return Approval'"
          @click="approveDecisionDealer(item)"
          >Approve Decision</v-btn
        >
      </v-card-actions> -->
    </v-card>

    <v-row justify="center">
      <v-dialog v-model="ItemConditionPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <span>Item Condition Validation ""</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="ItemConditionPopup = !ItemConditionPopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-layout column>
                  <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                    <v-data-table
                      :dense="true"
                      v-model="selected"
                      :items="d2cReturn_table_data"
                      disable-pagination
                      :hide-default-footer="true"
                      :headers="d2cReturn"
                      fixed-header
                      height="100%"
                      loading-text="Loading Data... Please wait"
                      class="elevation-1"
                      return-object
                    >
                    </v-data-table>
                  </v-col>
                </v-layout>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Test Result Popup -->
    <v-row justify="center">
      <v-dialog v-model="testResultPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <span>Test Results</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="testResultPopup = !testResultPopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Ticket Resolution</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- Replace part -->
                    {{ item_details.ticket_resolution ?  item_details.ticket_resolution : "-" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Item Decision</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- Return -->
                    {{ item_details.item_decision ?  item_details.item_decision : "-" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Inspection Questions</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <div v-if="item_details.condition_questions && item_details.condition_questions.length">
                      <ul>
                        <li style="list-style-type:none;" v-for="item in item_details.condition_questions" :key="item.question">
                          Q. {{ item.question }} : {{ item.answer }}
                        </li>
                      </ul>
                    </div>
                    <span v-else>-</span><br>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Estimated Service Cost (₹)</span>
                  </v-col>
                  <v-col cols="6" v-if="item_details.estimated_service_cost == 0">
                    {{item_details.estimated_service_cost}}
                  </v-col>
                  <v-col cols="6" v-else-if="item_details.estimated_service_cost == null">
                    {{"-"}}
                  </v-col>
                  <v-col cols="6" v-else>
                    {{item_details.estimated_service_cost}}
                  </v-col>

                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Type of Defect</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- In Policy -->
                    {{ item_details.type_of_defect ?  item_details.type_of_defect : "-" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Service Engineer Name</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- John Abrahim -->
                    <span>{{  item_details.service_partner_name ? item_details.service_partner_name : '-' }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Defective Spare Parts Information</span>
                  </v-col>
                  <v-col cols="6">
                    <div v-if="item_details.defective_spare_part_info && item_details.defective_spare_part_info.length">
                      <li style="list-style-type:none;" v-for="spare_info in item_details.defective_spare_part_info">
                        {{ spare_info }}
                      </li>
                    </div>
                    <span v-else>-</span>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- View Test Results Popup -->
        <v-row justify="center">
          <v-dialog v-model="packagingConditionPopup" items="item_details" persistent max-width="720px">
            <v-card class="v-card-100">
              <v-card class="v-card-100 mt-0 custom-shadow">
                <v-card-title class="pa-0">
                  <v-row class="ma-2">
                  <span class="font-weight-bold">Grading Details</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="packagingConditionPopup = false">mdi-close</v-icon>
                </v-row>
                </v-card-title>
               </v-card>
              <v-card-text>
              <v-container class="pa-0">
                <v-tabs v-model="tab_index" class="custom-tabs">
                  <v-tab class="component-tab-heading" ripple :href="'#'" @click="changeTab(tab)"
                    style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
                    :key="index">{{ tab }}</v-tab>
                </v-tabs>
                <div class="tag-details-style">
                 <v-row>
                   <v-col cols="12" sm="3">
                       <p>Tag ID</p>
                       <p class="detail-heading">{{ item_details.tag_number ? item_details.tag_number : "-" }}</p>
                   </v-col>
                   <v-col cols="12" sm="3">
                       <p>Article ID</p>
                       <p class="detail-heading">{{ item_details.sku_code ? item_details.sku_code : "-" }}</p>
                   </v-col>
                   <v-col cols="12" sm="3">
                       <p>Grading Date</p>
                       <p class="detail-heading" v-if="active_tab === 'Service Inspection'">{{ item_details.customer_declaration_result?.grader_details ? item_details.customer_declaration_result.grader_details.grading_date.split('-').reverse().join('-') : "-" }}</p>
                       <p class="detail-heading" v-else-if="active_tab === 'Packaging & Validation'">{{ item_details.grading_result?.grader_details ? item_details.grading_result.grader_details.grading_date.split('-').reverse().join('-') : "-" }}</p>
                   </v-col>
                   <v-col cols="12" sm="3">
                       <p>Graded By</p>
                       <p class="detail-heading" v-if="active_tab === 'Service Inspection'">{{ item_details.customer_declaration_result?.grader_details ? item_details.customer_declaration_result.grader_details.graded_by_name : "-" }}</p>
                       <p class="detail-heading" v-else-if="active_tab === 'Packaging & Validation'">{{ item_details.grading_result?.grader_details ? item_details.grading_result.grader_details.graded_by_name : "-" }}</p>
                   </v-col>
                   </v-row>
                   <v-row style="margin-top: -18px;">
                   <v-col cols="12" sm="3">
                       <p>Article Description</p>
                       <p class="detail-heading">{{ item_details.sku_description ? item_details.sku_description : "-" }}</p>
                   </v-col>
                   </v-row>
                   </div>
                   <div style="padding:10px; text-align: center;">
                   <div class="grade-point" v-if="active_tab === 'Service Inspection'"
                   :class="{
                        'accept-grade': item_details?.customer_declaration_result?.final_grade === 'Accept',
                        'reject-grade': item_details?.customer_declaration_result?.final_grade === 'Reject'
                      }"
                   >{{item_details?.customer_declaration_result?.final_grade ? item_details.customer_declaration_result.final_grade : "-"}}</div>
                   <div class="grade-point" v-if="active_tab === 'Packaging & Validation'"
                    :class="{
                        'accept-grade': item_details?.grading_result?.final_grade === 'Accept',
                        'reject-grade': item_details?.grading_result?.final_grade === 'Reject'
                      }"
                   >{{item_details?.grading_result?.final_grade ? item_details.grading_result.final_grade : "-"}}</div>
                   </div>
                  <!-- Loop over grading_result sections -->
                  <section v-if="active_tab === 'Service Inspection' && item_details?.customer_declaration_result?.final_grading_result 
                                && Object.keys(item_details.customer_declaration_result.final_grading_result).length">
                  <div v-for="(tests, sectionName) in item_details.customer_declaration_result.final_grading_result" :key="sectionName" class="mb-4">
                      <!-- Section title -->
                      <h5 class="font-weight-bold mb-2">
                          {{ formatSectionName(sectionName) }}
                      </h5>

                      <!-- Two-column test/answer layout -->
                      <v-row>
                          <v-col v-for="(testItem, idx) in tests" :key="idx" cols="12" sm="6">
                              <div>{{ testItem.test }}</div>
                              <div class="font-weight-bold">{{ testItem.value || '-' }}</div>
                          </v-col>
                      </v-row>
                  </div>
                  <div>
                  <h5 class="font-weight-bold mb-2">Images & Videos</h5>
                      <v-slide-group v-model="currentIndex" class="py-0" show-arrows center-active>
                          <v-slide-group-item v-for="(imageUrl, index) in mergedImages" :key="index" :value="index" class="thumb-wrapper">
                              <div class="thumb-container" :class="{ 'thumb-active': index === currentIndex }">
                                  <img :src="imageUrl" class="thumb-img" @click="openDialog(index)" />
                              </div>
                          </v-slide-group-item>
                      </v-slide-group>
                  </div>
                  </section>
                  <section class="overflow-y-auto dynamic-height-dis-card overflow-x-hidden" v-else-if="active_tab === 'Packaging & Validation' && item_details?.grading_result?.final_grading_result 
                                && Object.keys(item_details.grading_result.final_grading_result).length">
                  <div v-for="(tests, sectionName) in item_details.grading_result.final_grading_result" :key="sectionName" class="mb-4">
                      <!-- Section title -->
                      <h5 class="font-weight-bold mb-2">
                          {{ formatSectionName(sectionName) }}
                      </h5>

                      <!-- Two-column test/answer layout -->
                      <v-row>
                          <v-col v-for="(testItem, idx) in tests" :key="idx" cols="12" sm="6">
                              <div>{{ testItem.test ? testItem.test : testItem.question }}</div>
                              <div class="font-weight-bold">{{ testItem?.value?.toString() ? testItem.value.toString() : testItem.answer }}</div>
                          </v-col>
                      </v-row>
                  </div>
                  <div>
                  <h5 class="font-weight-bold mb-2">Images & Videos</h5>
                      <v-slide-group v-model="currentIndex" class="py-0" show-arrows center-active>
                          <v-slide-group-item v-for="(imageUrl, index) in mergedImages" :key="index" :value="index" class="thumb-wrapper" ref="slideGroup">
                              <div class="thumb-container" :class="{ 'thumb-active': index === currentIndex }">
                                  <img :src="imageUrl" class="thumb-img" @click="openDialog(index)"/>
                              </div>
                          </v-slide-group-item>
                       </v-slide-group>
                  </div>
                  </section>
                  <section v-else-if="active_tab === 'Customer Declaration'">
                  <div>
                   <v-row>
                         <v-col v-for="(testItem, idx) in item_details.condition_questions" :key="idx" cols="12" sm="6">
                             <div>{{ testItem.question }}</div>
                             <div class="font-weight-bold">{{ testItem.answer }}</div>
                         </v-col>
                      </v-row>
                  </div>
                    <div>
                     <h5 class="font-weight-bold mb-2">Images & Videos</h5>
                      <v-slide-group v-model="currentIndex" class="py-0" show-arrows center-active>
                          <v-slide-group-item v-for="(imageUrl, index) in mergedImages" :key="index" :value="index" class="thumb-wrapper" ref="slideGroup">
                              <div class="thumb-container" :class="{ 'thumb-active': index === currentIndex }">
                                  <img :src="imageUrl" class="thumb-img" @click="openDialog(index)"/>
                              </div>
                          </v-slide-group-item>
                       </v-slide-group>
                    </div>
                  </section>
                  <section v-else>
                  <span>No data found</span>
                  </section>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-dialog v-model="fullImageShow" persistent max-width="600">
            <v-card>
              <v-card class="v-card-100 mt-0 custom-shadow">
                <v-card-title class="pa-0">
                  <v-row class="ma-2">
                  <span class="font-weight-bold">View Image</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="fullImageShow = false">mdi-close</v-icon>
                </v-row>
                </v-card-title>
               </v-card>
              <v-card-text class="d-flex align-center justify-center">
                <v-btn icon @click="prevImage" :disabled="currentIndex === 0">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <v-img
                  :src="mergedImages[currentIndex]"
                  max-height="80vh"
                  contain
                ></v-img>

                <v-btn
                  icon
                  @click="nextImage(mergedImages[currentIndex])"
                  :disabled="currentIndex === mergedImages.length - 1"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
  </div>
</template>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import approval_decision from "./../../../../components/api/v2/return_approval/approval_decision.vue"
import Loading from 'vue-loading-overlay';

export default {
  components: {
    HeaderComponent, approval_decision, Loading
  },
  data() {
    return {
      table_data: [],
      CustomerLabelList: ["Customer Entity Details", "Item Details", "Test Details", "Customer Decelaration", "Other Details", "Status And Decision Details"],
      headerText: "",
      action: "Sub Request",
      testResultPopup: false,
      item_id: "",
      item: [],
      primary_code: "#0275d8",
      mainFullPage : true,
      loading: false,
      item_images: [],
      tab: "Ticket Details",
      tabs: ["Ticket Details", "Claim History"],
      headers: [
        { title: "Warranty Claim Date", align: "start", sortable: false, key: "warranty_claim_date" },
        { title: "Issue", key: "issue" },
        { title: "Warranty Resolution Date", key: "warranty_resolution_date" }
      ],
      activeTab: "Ticket Details",
      selected: "",
      ItemConditionPopup: false,
      d2cReturn: [],
      d2cReturn_table_data: [],
      item_details: [],
      item_videos: [],
      videoDialogVisible: false,
      selected_table: [],
      lebal_request: "",
      alert_type: "success",
      alert_message: "success",
      alert: false,
      dialogVisible: false,
      minTableHeight: "200px",
      action:'',
      currentUser:'',
      api_table_data: [],
      viewErrorLogPopup: false,
      error_log_data: '',
      selected2: [],
      request_log: '',
      response_log: '',
      api_headers: [
        { title: "API Instance", key: "payload_type",  sortable: false },
        { title: "API Method", key: "request_type", sortable: false},
        { title: "API Status", key: "status", sortable: false },
        { title: "Error Message", key: "error_string", sortable: false },
        { title: "", key: "re_trigger", sortable: false }
      ],
      selected_headers:[
        { title: "Client CRM Ticket No.", sortable: false, key: 'client_crm_ticket_no'},
        { title: "Sub-request ID", align: "start", sortable: false, key: "return_sub_request_id" },
        { title: "BB Ticket No.", key: "bb_ticket_no"},
        { title: "Ageings", key: "ageing" },
        { title: "Customer", key: "customer_name" },
        { title: "Purchase Dealer", key: "dealer_pan"},
        { title: "Location", key: "item_location" },
        { title: "Branch", key: "branch" },
        { title: "Region", key: "region" },
        { title: "Zone", key: "zone" },
        { title: "Validation", key: "policy"},
        { title: "Repairable", key: "repairable_status" },
        { title: "Repair As Value(₹)", key: "repair_cost" },
        { title: "Repair Cost %", key: "repair_cost_percent" },
        { title: "Customer Resolution Decision", key: "customer_resolution_decision" },
        { title: "Images", key: "images"},
        { title: "Item Decision", key: "item_decision" }
      ],
       packagingConditionPopup: false,
       showAllImages: false,
        currentIndex: 0,
        tabs: ["Service Inspection", "Packaging & Validation"],
        active_tab: "Service Inspection",
        tab_index: 0,
        fullImageShow: false,
        imageUrlsmerged: [],
    };
  },
  async created() {
    this.item_id = this.$store.state.lotIds.id;
    this.action = this.$store.state.action
    this.selected_table =  this.$store.state.active_tab;
    this.organization_name = this.$store.state.organization_name;
    this.headerText = this.$store.state.inventoryId;
    this.currentUser = this.$store.state.currentUser.roles[0];
    if (this.headerText === "D2C Return Approval") {
      this.lebal_request = "D2C";
    } else if (this.headerText === "Dealer/Partner Return Approval") {
      this.lebal_request = "Dealer";
    } else if (this.headerText === "Warranty Claim Approval" || this.headerText === "Customer Case Approval") {
      this.selected_headers = this.selected_headers.filter(header => header.value !== "dealer_pan");
      if(this.organization_name === 'Voltas'){
        this.headerText = 'Customer Case Approval';
      }else{
        this.headerText = 'Warranty Claim Approval';
      }
      this.lebal_request = "Warranty";
    }else if (this.headerText === "Internal Return Request Approval") {
      this.lebal_request = "Internal Return";
    }
     if(this.organization_name === "Blubirch"){
        this.tabs.unshift("Customer Declaration")
        this.active_tab = "Customer Declaration";
      }

    if(this.action !== 'from_home_approve'){
      this.calculateTableHeight();
      this.itemDetailsFtechData();
    }
  },
  mounted() {
    this.selected = this.selected_table;
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  computed: {
    checkGradingDetails() {
        return this.item_details?.grading_result?.final_grading_result 
                 && Object.keys(this.item_details.grading_result.final_grading_result).length || this.item_details?.customer_declaration_result?.final_grading_result 
                                && Object.keys(this.item_details.customer_declaration_result.final_grading_result).length || this.item_details?.condition_questions?.length
      },
      mergedImages() {
         const results = this.active_tab === 'Service Inspection' ? this.item_details?.customer_declaration_result?.final_grading_result : this.item_details?.grading_result?.final_grading_result || {};
          let urls = [];

          Object.values(results).forEach(testArray => {
            testArray.forEach(test => {
              if (Array.isArray(test.imageHolder)) {
                test.imageHolder.forEach(imgObj => {
                  if (imgObj.imageSrc) urls.push(imgObj.imageSrc);
                  if (imgObj.originalImageSrc) urls.push(imgObj.originalImageSrc);
                  if (imgObj.annotatedImageSrc) urls.push(imgObj.annotatedImageSrc);
                });
              }
            });
          });
          this.imageUrlsmerged = urls;
         let uniqueUrls = this.active_tab === 'Customer Declaration' ?  [...new Set(this.item_details?.images)] : [...new Set(urls)];
          return uniqueUrls;
        },
    shouldShowActualValue() {
      return this.currentUser === 'branch_sales_manager' ||
            this.currentUser === 'regional_business_head' ||
            this.currentUser === 'product_head' || 
            this.currentUser === 'branch_finance_manager' || 
            this.currentUser === 'regional_finance_manager';
    }
  },
  methods: {
    calculateTableHeight() {
      const viewportHeight = window.innerHeight;
      if(this.headerText === 'Reverse Logistics'){
        this.minTableHeight = (viewportHeight - 130) + 'px'
      }else{
        this.minTableHeight = (viewportHeight - 400) + 'px'
      }
    },
    // show Test Result Popup
    formatResponse(response) {
      return response ? response.replace(/_/g, ' ') : "-";
    },
    showTestResult() {
      this.testResultPopup = true;
    },
    getRouterLink() {
      if (this.headerText === "D2C Return Approval") {
        return { name: "dealer_partner_return_approval" };
      } else if (this.headerText === "Internal Return Request Approval") {
        return { name: "internal_return_approval" };
      } else if (this.headerText === "Warranty Claim Approval" || this.headerText === "Customer Case Approval") {
        return { name: "dealer_partner_return_approval" };
      } else if (this.headerText === "Dealer/Partner Return Approval") {
        return { name: "dealer_partner_return_approval" };
      }else if (this.headerText === "Reverse Logistics") {
        return { name: "ReverseLogistics" };
      }
    },
    viewCustomerDeclarationImages(item) {
      this.dialogVisible = true;
      this.item_images = item.images
    },
    viewCustomerDeclarationVideos(item) {
      this.videoDialogVisible = true;
      this.item_videos = item.videos
    },
    componentsName() {
      if (
        this.headerText === "D2C Return Approval" ||
        this.headerText === "Internal Return Request Approval" ||
        this.headerText === "Warranty Claim Approval" ||
        this.headerText === "Dealer/Partner Return Approval" ||
        this.headerText === "Reverse Logistics" ||
        this.headerText === "Customer Case Approval"
      ) {
        return this.action !== 'from_home_approve' 
        ? this.$store.state.lotIds.return_sub_request_id
        : "Approval Decision"
      }
    },
    getRouterLinkText() {
      if (this.headerText === "D2C Return Approval") {
        return this.headerText;
      } else if (this.headerText === "Internal Return Request Approval") {
        return this.headerText;
      } else if (this.headerText === "Warranty Claim Approval" || this.headerText === "Customer Case Approval") {
        let headerName = ''
        if(this.organization_name === 'Voltas'){
          headerName = 'Customer Case Approval';
        }else{
          headerName = 'Warranty Claim Approval';
        }
        return headerName;
      } else if (this.headerText === "Dealer/Partner Return Approval") {
        return this.headerText;
      } else if (this.headerText === "Approval Decision"){
        return this.headerText;
      }else if (this.headerText === "Reverse Logistics"){
        return this.headerText;
      }
    },
    formattedDate(date) {
      const d = new Date(date);
      const day = String(d.getUTCDate()).padStart(2, '0');
      const month = String(d.getUTCMonth() + 1).padStart(2, '0');
      const year = d.getUTCFullYear();
      
      return `${day}/${month}/${year}`;
    },
    approveDecision() {
      this.$store.commit("setLotIds", {
        lotIds: this.$store.state.lotIds,
        inventoryId: this.headerText,
        subInventoryId: "Sub Request"
      });
      this.$router.push({ name: "approval_decision" });
    },
    approveDecisionD2C(item) {
      this.$store.commit("setLotIds", {
        lotIds: this.$store.state.lotIds,
        inventoryId: this.headerText,
        subInventoryId: "Sub Request"
      });
      this.$router.push({ name: "approval_decision" });
    },
    approveDecisionWarranty(item) {
      this.$store.commit("setLotIds", {
        lotIds: this.$store.state.lotIds,
        inventoryId: this.headerText,
        subInventoryId: "Sub Request"
      });
      this.$router.push({ name: "approval_decision" });
    },
    approveDecisionDealer() {
      this.$store.commit("setLotIds", {
        lotIds: this.$store.state.lotIds,
        inventoryId: this.headerText,
        subInventoryId: "Sub Request"
      });
      this.$router.push({ name: "approval_decision" });
    },
    subRequestDialog(item){
      this.item_id = item.id
      this.action = "single_item_approve";
      this.$store.commit("setApproveLinkId", {
        requestIDs: item,
        requestAction: this.headerText,
        subId: "Sub Request"
      });
      this.$router.push({name: 'selected_details'});
    },
    closeDialog(){
      this.dialogVisible = false;
      this.videoDialogVisible = false;
    },
    loadData(tab, tab_action) {
      if (tab_action) {
        this.search_tag = "";
      }
      this.selected = [];
      this.page = 1;
      this.totalPages = 1;
      this.pageSize = 100;
      this.isFilteringPage = false;
      this.filterPageNo = 1;
      this.activeTab = tab;
    },
    ItemDetailsTable() {
      this.ItemConditionPopup = true;
      this.d2cReturn = [
        { title: "Validation", align: "start", sortable: false, key: "validation_items" },
        { title: "Risk", key: "issue" },
        { title: "Comment", key: "resolution" }
      ];
    },
    itemDetailsFtechData() {
      this.loading = true;
      this.$httpSecured
        .get(
          `/api/v1/warehouse/return_initiation/return_approvals/${this.item_id}`
        )
        .then(response => {
          if (response.data) {
            this.item_details = response.data.return_item;
            this.table_data = response.data.return_item.warranty_claim_data
            this.loading = false;
            this.apiIntegration(this.item_id);
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    apiIntegration(item_id){
      this.$httpSecured
      .get(`/api/v1/warehouse/return_initiation/return_creations/${this.item_id}/api_payloads`)
      .then(response => {
          if (response.data) {
            this.api_table_data = response.data.api_payloads;
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.isLoading = false;
        });
    },
    itemDetailpopup(item) {
      this.error_log_data = item.error_string ? item.error_string.error_message ? item.error_string.error_message : item.error_string['Error Message'] : "No error message available";
      this.request_log = item.request_payload;
      this.response_log = item.response_payload;
      this.viewErrorLogPopup = true;
    },
    retrigger(item) {
      this.$httpSecured
        .put(`/api/v1/warehouse/return_initiation/return_creations/${item.id}/retry_api_payload `)
        .then(response => {
          if (response.data) {
            this.$toast.success(response.data.message);
            this.apiIntegration(item);
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert('error', error.response.data.message);
          this.loading = false;
        });
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    start_loading() {
      this.loading = true;
    },
    stop_loading() {
      this.loading = false;
    },
    viewPackaging(){
        this.packagingConditionPopup = true;
      },
      formatSectionName(name) {
        return name.replace(' Condition', '');
      },
    openDialog(index) {
      this.currentIndex = index;
      this.fullImageShow = true;
    },
     prevImage() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
        }
      },
      nextImage(val) {
        if (this.currentIndex < this.mergedImages.length - 1) {
          this.currentIndex++;
        }
      },
    changeTab(tab) {
        this.active_tab = tab;
      },
  }
};
</script>

<style scoped>
.expansion-panel-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.expansion-panel-text {
  margin-right: 16px;
  font-weight: bold;
}
p {
  margin-bottom: 0 !important;
}
/* .v-expansion-panels {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  z-index: auto !important;
} */
 .customer-details {
  background-color: #EAF4FF;
 }
 .customer-details label {
  color: #002F9E;
  font-weight: 600;
  font-size: 18px;
 }
 .detail-heading {
  font-weight: 600;
  color: #2D2D2D;
  font-size: 14px;
 }

 :deep(.v-data-table tr.v-data-table__selected) {
  background-color: #E1EEFA !important;
}
.v-tooltip__content {
  background-color: white !important; 
  color: black !important;           
  border: 1px solid #ccc;            
  padding: 10px;                     
  font-size: 14px;                  
}
.thumb-wrapper {
    flex: 0 0 auto !important;
    margin-right: 8px;
  }

  .thumb-container {
    width: 90px;
    height: 95px;
    border-radius: 12px !important;   /* 🔒 Ensures radius on container */
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    box-sizing: border-box;
  }

  .thumb-img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    border-radius: 12px !important;   /* 🔒 Force radius on image too */
  }
  ::v-deep(.v-slide-group__container .v-slide-group__content) {
    display: flex !important;
    justify-content: left !important;
    align-items: left !important;
  }
  .v-btn__content{
    font-size: 16px !important;
  }
  .media-content {
    max-width: 300px;
    max-height: 400px;
    width: auto;
    height: auto;
    object-fit: contain;
    border-radius: 8px;
  }
  :deep(.custom-tabs .v-tab--selected) {
      text-transform: none;
      color: #002F9E;
      height: 36px !important;
      background-color:#E1F1FF !important;
      font-size: 12px;
      font-weight: 500 !important;
      line-height: 16.8px !important;
  }
  .tag-details-style{
    background-color: #EAF4FF;
    border-radius: 8px;
    padding: 10px;
  }
  .grade-point{
    width: 80px;
    padding: 7px;
    position: relative;
    left: 41%;
    font-weight: 600;
  }
  .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 500px) !important;
  }
  .accept-grade {
    background: #E1FAE1;
    color: #157F15;
  }

  /* Reject */
  .reject-grade {
    background: #FDEAEA;
    color: #C62828;
  }
</style>
